import { useState, useEffect } from "react";

const Checkbox = ({ label, isRequired, value = [], options, onChange = () => {} }) => {
  const [state, setState] = useState(value);

  useEffect(() => {
    onChange(state);
  }, [state]);

  const handleChange = (checked, value) => {
    if (checked) {
      if (!state.includes(value)) {
        setState([...state, value]);
      }
    } else {
      state.splice(state.indexOf(value), 1);
      setState([...state]);
    }
  };

  return (
    <>
      {label && (
        <label className="mmmbaa_label">
          {label}
          {isRequired ? <span className="required_star">*</span> : ""}
        </label>
      )}
      {Array.isArray(options) &&
        options.map((option, index) => {
          const value = option.label || option;
          return (
            <label key={index} className="input_checkbox_radio_item input_checkbox_item">
              {value}
              <input id={`input-ch-${index}`} type="checkbox" value={value} checked={state.includes(value)} onChange={(e) => handleChange(e.target.checked, value)} />
              <span className="checkmark"></span>
            </label>
          );
        })}
    </>
  );
};

export default Checkbox;
